import { render } from "./CompanyStructue.vue?vue&type=template&id=01032dce&scoped=true"
import script from "./CompanyStructue.vue?vue&type=script&lang=js"
export * from "./CompanyStructue.vue?vue&type=script&lang=js"

import "./CompanyStructue.vue?vue&type=style&index=0&id=01032dce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01032dce"]])

export default __exports__